import { AUTH_USER, LOGOUT_USER, TOKEN_EXPIRED, API_RESET_PASSWORD, API_FORGOT_PASSWORD } from "../actions/user";
import { DEFAULT_CLIENT, V2_CLIENT } from "config/clientConstants";
import { setAuthHeader, clearAuthHeader } from "utils/setAuthHeader";

export const getVersion = (action) => {
	const path = pathMapping[action];
	return {
		path: path[path.currentClient],
		currentClient: path.currentClient,
	}
}

const pathMapping = {
	[AUTH_USER]: {
		default: '/auth/login',
		v2: '/auth/login',
		currentClient: V2_CLIENT,
	},
	[LOGOUT_USER]: { // userId is required for v1
		default: (userId) => `/auth/token/${userId}/revoke`,
		v2: '/auth/revoke',
		currentClient: V2_CLIENT,
	},
	[TOKEN_EXPIRED]: {
		default: '/auth/token/expired',
		// v2: '/auth/token/expired',
		currentClient: DEFAULT_CLIENT,
	},
	[API_RESET_PASSWORD]: {
		default: '/users/reset',
		v2: '/users/reset',
		currentClient: V2_CLIENT,
	},
	[API_FORGOT_PASSWORD]: {
		default: '/auth/reset-password',
		// v2: '/auth/reset-password',
		currentClient: DEFAULT_CLIENT,
	},
}

export function authUser(credentials) {
	const version = getVersion(AUTH_USER);
	return {
		type: AUTH_USER,
		payload: {
			client: version.currentClient,
			request: {
				url: version.path,
				method: "POST",
				data: credentials,
			},
			options: {
				async onSuccess({ getState, dispatch, response }) {
					if (response.data) {
						setAuthHeader(response.data.token, 'both');

						dispatch({ type: `${AUTH_USER}_SUCCESS`, payload: response.data });
						dispatch({ type: "RESET_CENTER" });
					}
				},
				onError({ getState, dispatch, error }) {
					dispatch({ type: `${AUTH_USER}_FAIL`, payload: error.response ? error.response.data : null });
				},
			},
		},
	};
}

export function logOutUser(userId, refreshToken) {
	const version = getVersion(LOGOUT_USER);
	clearAuthHeader();

	return {
		type: LOGOUT_USER,
		payload: {
			client: version.currentClient,
			request: {
				url: version.path,
				method: "POST",
				data: { refreshToken: refreshToken },
			},
		},
	};
}

export function tokenExpired() {
	const version = getVersion(TOKEN_EXPIRED);
	clearAuthHeader();

	return {
		type: TOKEN_EXPIRED,
	};
}

export function resetPassword(password) {
	const version = getVersion(API_RESET_PASSWORD);
	return {
		type: API_RESET_PASSWORD,
		payload: {
			client: version.currentClient,
			request: {
				url: version.path,
				method: "PATCH",
				data: {
					password: password,
				},
			},
		},
	};
}

export function forgotPwd(data) {
	const version = getVersion(API_FORGOT_PASSWORD);
	return {
		type: API_FORGOT_PASSWORD,
		payload: {
			client: version.currentClient,
			request: {
				url: version.path,
				method: "POST",
				data: {
					email: data.email,
				},
			},
		},
	};
}
